import mod from "./inputmask.js";
const inputmask = mod.default || mod;
export default inputmask;
